import styled from 'utils/emotion';

export const PageBuilderSliderFadeStyled = styled('div')({});
